import React from 'react';
import { withStyles, BodyText } from 'vopay';
import styles from './DetailsRows.module.scss';

const classes = withStyles(styles);

interface DetailRow {
  label: React.ReactNode;
  value: React.ReactNode;
}

interface DetailsRowsProps {
  details: DetailRow[];
  className?: string;
}

const DetailsRows: React.FC<DetailsRowsProps> = ({ details, className }) => {
  if (details.length === 0) {
    return null;
  }

  return (
    <div className={classes('detailsContainer', className)}>
      {details.map((detail, index) => (
        <div key={index} className={classes('detailRow')}>
          <BodyText weight="md">{detail.label}</BodyText>
          <BodyText className={classes('detailValue')}>{detail.value}</BodyText>
        </div>
      ))}
    </div>
  );
};

export default DetailsRows;
